var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { UserAvatar } from '@web/components/UserAvatar';
import { getUserOrgUnit } from '@web/utility';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
export function SelectUserCards(_a) {
    var users = _a.users;
    var t = useTranslation().t;
    var navigateTo = useNavigateTo();
    var location = useLocation();
    var handleUserSelect = function (selectedUser) {
        var newFilters = {
            user: selectedUser.id
        };
        var userOrgUnit = getUserOrgUnit(selectedUser);
        if (userOrgUnit) {
            newFilters.orgUnit = userOrgUnit;
        }
        navigateTo({
            pathname: location.pathname,
            newFilters: newFilters
        });
    };
    if (users.length === 0) {
        return null;
    }
    return (_jsx("div", __assign({ className: "bg-white py-6 sm:py-8" }, { children: _jsx("div", __assign({ className: "mx-auto max-w-7xl px-6 lg:px-8" }, { children: _jsx("ul", __assign({ className: "mx-auto grid max-w-2xl grid-cols-2 gap-x-8 gap-y-16 text-center sm:grid-cols-3 md:grid-cols-4 lg:mx-0 lg:max-w-none lg:grid-cols-5 xl:grid-cols-6" }, { children: users.map(function (user) { return (_jsxs("li", __assign({ onClick: function () { return handleUserSelect(user); }, className: "cursor-pointer hover:opacity-80 transition-opacity" }, { children: [_jsx("div", __assign({ className: "mx-auto flex justify-center" }, { children: _jsx("div", __assign({ className: "size-24 rounded-full outline-1 -outline-offset-1 outline-black/5 flex items-center justify-center" }, { children: _jsx(UserAvatar, { size: "2xl", user: user }) })) })), _jsx("h3", __assign({ className: "mt-6 text-base/7 font-semibold tracking-tight text-gray-900" }, { children: user.name || user.email })), _jsx("p", __assign({ className: "text-sm/6 text-gray-600" }, { children: user.email })), user.creationDate && (_jsx("p", __assign({ className: "text-xs/5 text-gray-500 mt-1" }, { children: t('app.performanceReview.employeePerformanceReview.joinedOrg', {
                                date: format(new Date(user.creationDate), 'dd MMM yyyy')
                            }) })))] }), user.id)); }) })) })) })));
}
